import { v4 as uuid } from 'uuid';
import { CustomColumnHeader, Lot } from 'types';

/**
 * Create a new empty lot for import
 * @param name
 * @param customColumnHeaders
 * @param lotsCount
 */
export const newEmptyLot = (
  name: string,
  customColumnHeaders: CustomColumnHeader[] = [],
  lotsCount = 0
) => {
  const lotId = `new-${uuid()}`;

  return {
    custom_column_headers: customColumnHeaders,
    errors: [],
    id: lotId,
    line_items: [],
    name,
    sno: lotsCount,
  } as Partial<Lot>;
};
